import { queries as configurationQueries } from "domains/admin/containers/Configuration/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: Parameters<typeof configurationQueries>[0]): Array<WarmableQuery> =>
  configurationQueries(input);
